<!-- Derived from Lucide (https://lucide.dev), ISC License; portions from Feather, MIT. See LICENSE in this folder. -->
<!-- A 2.75-unit shaft over the arrowhead and a solid tray. -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M11.625 3h0.75v8h-0.75zM7 10h10l-5 5zM3 15h3.343l2.829 2.828a4 4 0 0 0 5.656 0L17.657 15H21v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
    />
  </svg>
</template>
